// Meeting Keys
export const meetingKeyTypes={
    virtual: 'Virtual',
  meeting_at_office: 'Meeting at office',
}